import { createContext } from 'react';
import { getConfig, type AppConfig } from '@/runtime-config';

/**
 * AppConfigContext is a context that provides the config object containing env variable.
 */
const AppConfigContext = createContext<AppConfig | null>(null);

/**
 * A component that provides the config object containing env variable.
 * It wraps the application with AppConfigContext.Provider and passes the config object
 * obtained from getConfig() as its value.
 * This component should be used at the top level of the application, typically at the top
 * level of the App component.
 */
export function AppConfigProvider({ children }: { children: React.ReactNode }) {
  return (
    <AppConfigContext.Provider value={getConfig()}>
      {children}
    </AppConfigContext.Provider>
  );
}
